import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDownRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowDownRight"><Path d="M18.5 8.5V18.5H8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18 18L6 6" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowDownRight;
